import { Box, IconButton } from "@seneca/senekit";

type Props = {
  onClick: () => void;
  sidebarOpen: boolean;
};

export default function SidebarToggle({ onClick, sidebarOpen }: Props) {
  return (
    <Box dataTest="SidebarToggleButton">
      <IconButton
        iconName="hamburgerMenu"
        onClick={onClick}
        accessibilityLabel={`${sidebarOpen ? "Close" : "Open"} sidebar`}
        blend
      />
    </Box>
  );
}
